import { Fragment, memo } from 'react'

import { getTableRowQaProps, TableCellFreeSpaceFiller } from '../../Table'

import { renderCategoryCell } from './CategoryTableRow.utils'

import * as styles from './CategoryTableRow.module.css'

function CategoryTableRow({
  columns,
  emptyColumnSize,
  isResizing,
  item,
  resizingColumn,
  scrollRef,
  showCellBorder,
}) {
  const qaProps = getTableRowQaProps()

  return (
    <div {...qaProps} className={styles.CategoryTableRow}>
      {columns.map(column => (
        <Fragment key={column.name}>
          {renderCategoryCell({
            isActive: column.name === resizingColumn,
            isResizing,
            item,
            name: column.name,
            scrollRef,
            showCellBorder,
            width: column.width,
          })}
        </Fragment>
      ))}
      <TableCellFreeSpaceFiller width={emptyColumnSize} />
    </div>
  )
}

export default memo(CategoryTableRow)
